<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.uid"
          :base="base"
          name="uid"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.auth_id"
          :base="base"
          name="auth_id"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.nickname"
          :base="base"
          name="nickname"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.contact_phone"
          :base="base"
          name="contact_phone"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.email"
          :base="base"
          name="email"
          :disabled="true"
          >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-if="formData.phone"
          v-model="formData.phone"
          :base="base"
          name="phone"
          :disabled="true"
          >
        </text-field>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'member-detail',
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      base: 'orders'
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>
